// DE · Recorrido de novedades (TourNovedades.vue)
export const tourNovedades = {
  "title": "Neu bei WA Checkin",
  "kicker": "Neuigkeiten",
  "stepOf": "Schritt {n} von {total}",
  "close": "Schließen",
  "dontShow": "Nicht mehr anzeigen",
  "prev": "Zurück",
  "next": "Weiter",
  "done": "Verstanden",
  "steps": {
    "icons": {
      "title": "Symbole an Ihren Buchungen",
      "text": "Jede Buchung im Kalender und in der Buchungsliste zeigt jetzt kleine Symbole: Anfragen an die KI-Rezeption, Anrufe, Notizen und ob noch Geld offen ist. Fahren Sie mit der Maus darüber, um die Details zu sehen, ohne die Buchung zu öffnen.",
      "cta": ""
    },
    "early": {
      "title": "Früher Check-in gegen Gebühr",
      "text": "Der frühe Check-in kann jetzt etwas kosten. Der KI-Agent fragt nach der Ankunftszeit, berechnet den Preis und sendet den Zahlungslink. Sobald bezahlt ist, wird er automatisch bestätigt.",
      "cta": "Im KI-Agenten einrichten"
    },
    "reception": {
      "title": "KI-Rezeption",
      "text": "Alles, was Ihre Gäste beim Agenten anfragen (früher rein, später raus, zusätzliche Nächte, Rechnungen, Anrufnachrichten), landet in einem Posteingang. Mit einem Klick annehmen, ablehnen oder priorisieren und den Betrag des Berechneten sehen.",
      "cta": "KI-Rezeption öffnen"
    },
    "translate": {
      "title": "Echtzeit-Übersetzung",
      "text": "Aktivieren Sie im Chat jeder Buchung und im Posteingang die Übersetzung: Was der Gast schreibt, erreicht Sie in Ihrer Sprache, und mit Enter sehen Sie Ihre Nachricht zuerst in seiner Sprache, bevor sie gesendet wird.",
      "cta": "Zu den Nachrichten"
    },
    "voice": {
      "title": "Anrufe mit dem Sprachagenten",
      "text": "Aktivieren Sie die Telefonrezeption: Der KI-Agent nimmt Anrufe in der Sprache des Anrufers an, beantwortet Fragen, sendet den Buchungslink und hinterlässt Ihnen eine Zusammenfassung jedes Anrufs.",
      "cta": "Anrufe aktivieren"
    }
  },
  "demo": {
    "iconsTipTitle": "KI-Rezeption",
    "iconsTipEarly": "Früher Check-in",
    "iconsTipPending": "Offen:",
    "paid": "Bezahlt",
    "earlyGuest": "Können wir um 11:00 Uhr einchecken?",
    "earlyAgent": "Ja! Der Check-in um 11:00 Uhr kostet 30 €. Hier können Sie zahlen:",
    "earlyPaid": "Bezahlt · bestätigt",
    "rx": {
      "early": "Früher Check-in",
      "late": "Später Check-out",
      "extend": "Verlängerung"
    },
    "pending": "Ausstehend",
    "confirmed": "Bestätigt",
    "trGuestOrig": "What time can we pick up the keys?",
    "trGuestMine": "Wann können wir die Schlüssel abholen?",
    "trMine": "Ab 15:00 Uhr, wir freuen uns auf Sie",
    "trTheirs": "From 3 pm, we look forward to seeing you",
    "voiceSummaryTitle": "Anrufzusammenfassung",
    "voiceSummary": "Hat nach dem Parkplatz gefragt und 2 Nächte gebucht. Buchungslink per WhatsApp gesendet."
  }
};
